import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon, Url } from '#const';
import { getIconUrl } from '#utils';

const Layout = dynamic(() => import('./Layout'));

Builder.registerComponent(Layout, {
	name: 'Layout',
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Hero',
				options: {
					heading: '<h1><strong>ATTENTION</strong></h1>',
					copy: '<p>Placeholder desktop body text.</p>',
					mobileHeading: '<h1><strong>ATTENTION:</strong></h1>',
					mobileCopy: '<p>Placeholder mobile body text.</p>',
				},
			},
		},
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Form',
				options: {
					headingCopy: `<h2>Find Out if You Qualify</h2>
						<br/> <h3><u>SIGNIFICANT</u> Compensation May Be Available</h3>`,
				},
			},
		},
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'LogoBar',
				options: {
					heading: 'As Seen On:',
				},
			},
		},
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'SecondaryHero',
				options: {
					heading: '<p>Placeholder heading: <u>Time is limited</u> to File!</p>',
					copy: '<p>Placeholder body text.</p>',
					line: false,
					image: {
						src: Url.PLACEHOLDER_IMAGE,
						alt: '',
					},
				},
			},
		},
	],
	childRequirements: {
		message: `Child may be any of: Hero, Secondary Hero, Form, 'SingleForm', HeroWithImage,
		Header, HeaderV2, LogoBar, CopyAndImage, ThreeColumn, Settlements, Accordion, Cta Section, Icon List,
		MainHeader, ListAndImage, TrapezoidHero, Listicle, ContactUs, BragBar, MiniSplash, BulletedImageList, StickyCTA, TestimonialCarousel`,
		query: {
			'component.name': {
				$in: [
					'Form',
					'SingleForm',
					'Hero',
					'HeroWithImage',
					'SecondaryHero',
					'LogoBar',
					'Header',
					'HeaderV2',
					'CopyAndImage',
					'ThreeColumn',
					'Settlements',
					'Accordion',
					'CtaSection',
					'IconList',
					'MainHeader',
					'ListAndImage',
					'TrapezoidHero',
					'Listicle',
					'ContactUs',
					'BragBar',
					'MiniSplash',
					'BulletedImageList',
					'StickyCTA',
					'TestimonialCarousel',
				],
			},
		},
	},
	image: getIconUrl(Icon.LAYOUT),
});
